export const data = Array.from(Array(20).keys()).map((index) => ({
  "File Name": `CV_John_Doe_${index}.pdf`,
  "Uploaded At": "2023/01/01",
  "Uploaded By": "John Doe",
  "Customer ID": 1,
  Location: "UK",
}))
